import { render, staticRenderFns } from "./ModalGraphqlSearchContent.vue?vue&type=template&id=0f523723"
import script from "./ModalGraphqlSearchContent.vue?vue&type=script&lang=js"
export * from "./ModalGraphqlSearchContent.vue?vue&type=script&lang=js"
import style0 from "./ModalGraphqlSearchContent.vue?vue&type=style&index=0&id=0f523723&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports